export function log({
  debug,
  message,
  ...args
}: {
  debug: boolean;
  message: string;
  [key: string]: any;
}): void {
  if (debug) {
    console.log("[BackRedirect Tracker]", message, args);
  }
}
